/* tslint:disable */
// Event implementation.  Allows an object to notify subscribed listeners of an event, passing
// a typed payload for event arguments.  Users of this class should keep the Event<T> private,
// and instead expose the object to the outside via the IEventListeners<T> interface to
// prevent other classes from firing the event.
var Event = /** @class */ (function () {
    function Event() {
        this._listeners = [];
    }
    /**
     * Fires an event to its listeners
     * @param args - The parameters of the event
     */
    Event.prototype.fireEvent = function (args) {
        this._listeners.forEach(function (listener) { return listener(args); });
    };
    /**
     * Add an event listener
     * @param listener - The listener that can process events
     */
    Event.prototype.addListener = function (listener) {
        if (listener) {
            this._listeners.push(listener);
        }
    };
    /**
     * Remove an event listener
     * @param listener - The listener to remove
     */
    Event.prototype.removeListener = function (listener) {
        this._listeners = this._listeners.filter(function (h) { return h !== listener; });
    };
    /**
     * Get the count of event listeners
     */
    Event.prototype.getListenerCount = function () {
        return this._listeners.length;
    };
    return Event;
}());
export { Event };
//# sourceMappingURL=Event.js.map